import { useNavigate, useSearchParams } from 'react-router-dom';
import { SETTINGS_PANEL } from '@/consts/searchKeys';
import { useUpdateQueryString } from '@/hooks/useUpdateQueryString';

export const useCloseSettingsPanel = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const updateQueryString = useUpdateQueryString(searchParams);

  return () => navigate(`?${updateQueryString([], [SETTINGS_PANEL])}`);
};
